import { Injectable } from '@angular/core';
import { ApiService } from '@services/api.service';

@Injectable({
    providedIn: 'root'
})
export class VisitorSuspensionService extends ApiService {
    getByVisitor(id: number) {
        return super.post('/visitors-suspension/visitor/' + id);
    }

    create(data: any) {
        return super.post('/visitors-suspension/create', data);
    }

    update(data: any) {
        return super.put('/visitors-suspension/update', data);
    }

    activate(data: any) {
        return super.put('/visitors-suspension/activate', data);
    }

    endAll() {
        return super.put('/visitors-suspension/end-all');
    }

    delete(id: number) {
        return super.delete('/visitors-suspension/' + id);
    }
}
